import config from "../config"
const baseUrl = config.base_url + "container_phenology_interaction/"

export default {
    page: {
        url: baseUrl + "page/{limit}/{page}",
        type: "get",
    },
    listBySubjectId: {
        url: baseUrl + "list_by_subjectId",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    },
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    interactionTypeList: {
        url: baseUrl + "interaction_type_list",
        type: "get",
    },
    subjectListByPhenology: {
        url: baseUrl + "subject/listByPhenology",
        type: "get",
    },
    subjectSaveWithInteractions: {
        url: baseUrl + "subject/saveWithInteractions",
        type: "post",
    },
    listByReproductiveId: {
        url: baseUrl + "subject/listByReproductiveId",
        type: "get",
    },
    copyToReproductive: {
        url: baseUrl + "subject/copyToReproductive",
        type: "get",
    },
    deleteItem: {
        url: baseUrl + "deleteItem",
        type: "get",
    },
}

